import { axiosInstance, requestConfig } from 'network/apis';

import { URL_SYSTEM } from "utils/constants";

export const callMenuList = async () => {
    return await axiosInstance(requestConfig('get', URL_SYSTEM, '/menus/shop-management'));
};